// Render a set of form buttons
import React, { useState, useEffect, useRef } from "react";
import { Elements, stripePromise, stripeElementsOptions } from "./Stripe.js";
import { useApi } from "../../hooks/UseApi";
import Donate from "./Donate";
import Join from "./Join";
import BillingSettingFields from "./BillingSettingFields";
import FormProcessCard from "./FormProcessCard";

const FormWithBilling = (props) => {
  const { get } = useApi();

  const [savedBilling, setSavedBilling] = useState([]);
  useEffect(() => {
    if (props.member) {
      get(
        `membership/user/${props.member.username}/billing`,
        null,
        "csrf"
      ).then((data) => {
        setSavedBilling(data);
      });
    }
  }, []);
  const [chosenMethod, setChosenMethod] = useState("saved");
  const handleChosenMethodSaved = () => {
    setChosenMethod("saved");
  };
  const handleChosenMethodNew = () => {
    setChosenMethod("new");
  };
  const [formError, setFormError] = useState();
  const handleFormError = (message) => {
    setFormError(message);
  };
  const loader = useRef(null);
  const submit = useRef(null);

  return (
    <Elements stripe={stripePromise} options={stripeElementsOptions}>
      <FormProcessCard
        savedBilling={savedBilling}
        chosenMethod={chosenMethod}
        handleChosenMethodSaved={handleChosenMethodSaved}
        handleChosenMethodNew={handleChosenMethodNew}
        formError={formError}
        handleFormError={handleFormError}
        loader={loader}
        submit={submit}
        action={props.action}
        fields={props.fields}
        formSuccess={props.formSuccess}
        handleFormSuccess={props.handleFormSuccess}
        member={props.member}
        newMember={props.newMember}
        handleNewMember={props.handleNewMember}
      >
        {props.action == "donate" && (
          <Donate
            savedBilling={savedBilling}
            chosenMethod={chosenMethod}
            handleChosenMethodSaved={handleChosenMethodSaved}
            handleChosenMethodNew={handleChosenMethodNew}
            loader={loader}
            submit={submit}
            formError={formError}
            formSuccess={props.formSuccess}
            member={props.member}
          />
        )}
        {props.action == "join" && (
          <Join
            loader={loader}
            submit={submit}
            formError={formError}
            formSuccess={props.formSuccess}
            member={props.member}
            newMember={props.newMember}
            handleNewMember={props.handleNewMember}
          />
        )}
        {props.action == "settings" && (
          <BillingSettingFields
            savedBilling={savedBilling}
            chosenMethod={chosenMethod}
            handleChosenMethodSaved={handleChosenMethodSaved}
            handleChosenMethodNew={handleChosenMethodNew}
            loader={loader}
            submit={submit}
            formError={formError}
            formSuccess={props.formSuccess}
            member={props.member}
            newMember={props.newMember}
            handleNewMember={props.handleNewMember}
            levels={props.levels}
            memberLevel={props.memberLevel}
          />
        )}
      </FormProcessCard>
    </Elements>
  );
};
export default FormWithBilling;
